/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

const is = require("is_js");

const SERVICE_NAME = "MyAccountService";
const log: any = LoggerModule.getInstance();

export class MyAccountPageService {
  private static instance: MyAccountPageService;
  private vapp: VApplication;
  private readonly loginRestAPI: string;
  private readonly headers: HeaderProps;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
    this.loginRestAPI = props?.loginRestAPI;
    this.headers = props?.headers;
  }

  public static getInstance(props: any = {}): MyAccountPageService {
    if (!MyAccountPageService.instance) {
      MyAccountPageService.instance = new MyAccountPageService(props);
    }
    return MyAccountPageService.instance;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();
    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async getPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    //Header Props
    compProps = await agent.getHeaderProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //Feature Section Props
    compProps = await agent.getFeatureSectionProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //Footer Props
    compProps = await agent.getFooterProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async updateProfile(args: any) {
    log.info(`update user service`, args);
    const agent = getAgent();
    return agent.getUpdateProfile(args);
  }

  public async updateKYC(args: any) {
    log.info(`update KYC service`, args);
    const agent = getAgent();
    return agent.getUpdateKyc(args);
  }

  public async sendOTP(args: any) {
    let _args = {
      ...args,
      apiURL: this.loginRestAPI,
      headers: this.headers,
    };
    const agent = getAgent();
    return agent.sendOTP(_args);
  }

  public async verifyOTP(args: any) {
    const agent = getAgent();
    return agent.getVerifyOTP(args);
  }

  public formatTimeLineDetail(args: any) {
    const agent = getAgent();
    return agent.getFormatTimelineDetailSync(args);
  }
}
